import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Solutions from "@/pages/Solutions";
import MSSP from "@/pages/MSSP";
import Awareness from "@/pages/Awareness";
import Alliances from "@/pages/Alliances";
import Industries from "@/pages/Industries";
import Labs from "@/pages/Labs";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Careers from "@/pages/Careers";
import Contact from "@/pages/Contact";
import Ecosystem from "@/pages/Ecosystem";
import Workforce from "@/pages/Workforce";
import Training from "@/pages/Training";
import Assistance from "@/pages/Assistance";
import AlliancePartner from "@/pages/AlliancePartner";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App min-h-screen bg-white font-body text-slate-700" data-testid="app-root">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main className="pt-7 md:pt-7">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ecosystem" element={<Ecosystem />} />
            <Route path="/enterprise-security" element={<Solutions />} />
            <Route path="/solutions" element={<Navigate to="/enterprise-security" replace />} />
            <Route path="/mssp" element={<MSSP />} />
            <Route path="/awareness" element={<Awareness />} />
            <Route path="/workforce" element={<Workforce />} />
            <Route path="/training" element={<Training />} />
            <Route path="/assistance" element={<Assistance />} />
            <Route path="/alliances" element={<Alliances />} />
            <Route path="/alliances/:slug" element={<AlliancePartner />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/labs" element={<Labs />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogPost />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
